import React from "react";

const Foot = () => {
  return (
    <div>
      <div className="fsa-footer fsa-footer--fullscreen">
        <div className="fsa-footer__bd">
          <div className="fsa-grid">
            <div className="fsa-footer__primary fsa-grid__1/1 fsa-grid__9/12@l">
              <div className="fsa-grid">
                <div className="fsa-grid__1/1 fsa-grid__1/4@m">
                  <div className="footLogoCon">
                    {/* <img
                      role="presentation"
                      className="fsa-logo"
                      src="img/usda-logo--white.svg"
                      alt=""
                    /> */}
                    <img
                      role="presentation"
                      src="img/Brillient-Logo.png"
                      alt=""
                    />
                    <a href="https://ask.usda.gov/s/?utm_source=USDA&utm_medium=homepage&utm_campaign=homepage%20referrals" target="_blank">
                      {/* AskUSDA */}
                    </a>
                  </div>

                </div>
                <div className="fsa-grid__1/1 fsa-grid__1/3@m">
                  <ul className="fsa-footer__list">

                    <li className="fsa-footer__list-item">
                      <a href="https://www.usda.gov" target="_blank">
                        {/* USDA.gov */}
                      </a>
                    </li>
                    <li className="fsa-footer__list-item">
                      <a href="https://www.usa.gov" target="_blank">
                        {/* USA.gov */}
                      </a>
                    </li>
                    <li className="fsa-footer__list-item">
                      <a href="https://www.whitehouse.gov/" target="_blank">
                        {/* WhiteHouse.gov */}
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="fsa-grid__1/1 fsa-grid__1/3@m">
                  <ul className="fsa-footer__list">
                    <li className="fsa-footer__list-item">
                      <a href="https://www.dm.usda.gov/foia/" target="_blank">
                        {/* FOIA */}
                      </a>
                    </li>

                    <li className="fsa-footer__list-item">
                      <a href="https://www.ocio.usda.gov/policy-directives-records-forms/information-quality-activities" target="_blank">
                        {/* Information Quality */}
                      </a>
                    </li>
                    <li className="fsa-footer__list-item">
                      <a href="https://www.usda.gov/plain-writing" target="_blank">
                        {/* Plain Writing */}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="fsa-footer__secondary fsa-grid__1/1 fsa-grid__3/12@l">
              <ul className="fsa-footer__list fsa-footer__secondary-list">
                <li className="fsa-footer__list-item fsa-footer__secondary-list-item">
                  <a href="https://www.usda.gov/privacy-policy" target="_blank" rel="noreferrer">
                    {" "}
                    Privacy Policy
                  </a>
                </li>
                <li className="fsa-footer__list-item fsa-footer__secondary-list-item">
                  <a href="https://www.usda.gov/accessibility-statement" target="_blank" rel="noreferrer">
                    {" "}
                    Accessibility Statement
                  </a>
                </li>

                <li className="fsa-footer__list-item">
                  <a href="https://www.usda.gov/non-discrimination-statement" target="_blank">
                    Non-Discrimination Statement
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>


    </div>
  );
};

export default Foot;
